<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top border-bottom navbar-expand"
    :class="$route.meta.navbarClasses ? $route.meta.navbarClasses : 'navbar-light'"
    type=""
  >
    
    <!-- Navbar links -->
    <ul class="navbar-nav align-items-center ml-md-auto">
      <li class="nav-item d-xl-none">
        <!-- Sidenav toggler -->
        <div class="pr-3 sidenav-toggler sidenav-toggler-light"
             @click="toggleSidebar">
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
          </div>
        </div>
      </li>
    </ul>

    <!-- User dropdown -->
    <ul class="navbar-nav align-items-center ml-auto ml-md-0">
      <li class="nav-item dropdown">
        <a class="nav-link pr-0" href="#" @click="onUserIconClick()" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <div class="media align-items-center">
            <div class="media-body mr-2 text-right d-none d-lg-block line-height-1">
              <span class="m-0 p-0 text-sm font-weight-bold">{{ firstName }} {{ lastName }}</span><br>
              <span class="m-0 p-0 text-xs font-weight-light text-muted">{{ groupEntityName }}</span>
            </div>
            <user-icon :firstName="firstName" :lastName="lastName"></user-icon>
          </div>
        </a>
        <div class="dropdown-menu dropdown-menu-right">
          <!-- <div class="dropdown-header noti-title">
            <h6 class="text-overflow m-0">Welcome!</h6>
          </div>
          <a href="#!" class="dropdown-item">
            <i class="ni ni-single-02"></i>
            <span>My profile</span>
          </a>
          <a href="#!" class="dropdown-item">
            <i class="ni ni-settings-gear-65"></i>
            <span>Settings</span>
          </a>
          <a href="#!" class="dropdown-item">
            <i class="ni ni-calendar-grid-58"></i>
            <span>Activity</span>
          </a>
          <a href="#!" class="dropdown-item">
            <i class="ni ni-support-16"></i>
            <span>Support</span>
          </a>
          <div class="dropdown-divider"></div> -->
          <a href="#!" @click="onLogoutClick($event)" class="dropdown-item">
            <i class="ni ni-user-run"></i>
            <span>Logout</span>
          </a>
        </div>
      </li>
    </ul>
  </base-nav>
</template>
<script>
  // Imports
  import { CollapseTransition } from 'vue2-transitions';
  import { BaseNav, Modal } from '@/components';
  import AuthService from '../../services/AuthService';
  import RetailerLeadsService from '../../services/RetailerLeadsService';
  import RetailersService from '../../services/RetailersService';
  import CharitiesService from '../../services/CharitiesService';
  import UserStore from '../../services/UserStore';
  import UserIcon from '../../components/UserIcon'
  //
  export default {
    components: {
      CollapseTransition,
      BaseNav,
      Modal,
      UserIcon
    },

    data() {
      return {
        activeNotifications: false,
        showMenu: false,
        searchModalVisible: false,
        searchQuery: '',
        firstName: '',
        lastName: '',
        group: '',
        groupEntityName: null
      };
    },

    computed: {
      routeName() {
        const { name } = this.$route;
        return this.capitalizeFirstLetter(name);
      },
      isRTL() {
        return this.$rtl.isRTL;
      }
    },

    async mounted(){
      this.firstName = UserStore.userData.firstName;
      this.lastName = UserStore.userData.lastName;

      if(UserStore.userData.group === 'retailerLead') {
        try {
          let retailerLeadRes = await RetailerLeadsService.getById(UserStore.userData.groupEntityId);
          this.groupEntityName = retailerLeadRes.data.name;
        }
        catch(err) {
          console.log(`RetailersLeadsService->Couldn't fetch Retailer Lead`);
        }
      }
      else if(UserStore.userData.group === 'retailers') {
        try {
          let retailerRes = await RetailersService.getById(UserStore.userData.groupEntityId);
          this.groupEntityName = retailerRes.data.name;
        }
        catch(err) {
          console.log(`RetailersService->Couldn't fetch Retailer`);
        }
      }
      else if(UserStore.userData.group === 'charities') {
        try {
          let charityRes = await CharitiesService.getById(UserStore.userData.groupEntityId);
          this.groupEntityName = charityRes.data.name;
        }
        catch(err) {
          console.log(`RetailersService->Couldn't fetch Retailer`);
        }
      }
      else if(UserStore.userData.group === 'admins') {
        this.groupEntityName = 'Food Drop Admin'
      }
    },

    methods: {
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications;
      },
      closeDropDown() {
        this.activeNotifications = false;
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },

      /**
       * User profile icon clicked so show the menu
       */
      onUserIconClick(){
        let menu = document.querySelector('.navbar-nav .dropdown-menu');
        if(menu.classList.contains('dropdown-menu--open')){
          menu.classList.remove('dropdown-menu--open');
        }else{
          menu.classList.add('dropdown-menu--open');          
        }
      },

      /**
       * 
       */
      async onLogoutClick(){
        console.log(1);
        await AuthService.logoutWeb();
        window.location ='/';
      }
    }
  };
</script>
<style scoped>
  .top-navbar {
    top: 0px;
  }
  .navbar-nav .dropdown-menu--open{
    display:block;
    opacity:1;
    pointer-events: all;
  }

  .line-height-1 {
    line-height: 1;
  }
</style>
